export const isEmpty = value => value === "" || value === null || value === undefined;
